import { createSlice } from '@reduxjs/toolkit'

export const campaignSlice = createSlice({
  name: 'campaign',
  initialState: {
    metroList: []
  },
  reducers: {
    setMetroList: (state, action) => {
      state.metroList = action.payload
    },
  }
})

export const { setMetroList } = campaignSlice.actions
export default campaignSlice.reducer